module.exports = __webpack_public_path__ + "static/images/type2bg.ab8e361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/type2bg.jpg
// module id = XwAm
// module chunks = 1